import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RadioIcon(props: IconProps) {
    return <Icon {...props} iconKey={"radio"}/>
}
